<template>
  <!-- 会议报名表单 -->
  <div>
    <div class="form-enroll">
      <div id="anchorTagTwo" class="h">会议报名</div>
      <div
        v-for="(conferee, index) in newArrayFrom"
        :key="conferee.id"
        class="form"
      >
        <Form
          @submit.native.prevent
          ref="formValidate"
          :model="item"
          v-for="item in conferee.signUpDtos"
          :key="item.code"
          :label-width="80"
        >
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'change',
              },
            ]"
            prop="content"
            v-if="item.code === 'name'"
            :label="item.value"
          >
            <Input
              :ref="'disabled' + index"
              v-model="item.content"
              :maxlength="10"
              placeholder="请输入姓名"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
              {
                pattern:
                  /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
                message: '格式错误',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'phone'"
            :label="item.value"
          >
            <Input
              @on-blur="blur(item.content, index)"
              v-model="item.content"
              :maxlength="11"
              placeholder="请输入手机号"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '至少选择一种',
                trigger: 'change',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'gender'"
            label="性别"
          >
            <RadioGroup v-model="item.content">
              <Radio label="male">男</Radio>
              <Radio label="female">女</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'nation'"
            label="民族"
          >
            <Input
              v-model="item.content"
              placeholder="请输入民族"
              :maxlength="20"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'change',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'birth'"
            label="出生年月"
          >
            <Row>
              <Col span="12">
                <DatePicker
                  @on-change="item.content = $event"
                  :value="item.content"
                  format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择出生年月"
                ></DatePicker>
              </Col>
            </Row>
          </FormItem>
          <div v-else-if="item.code === 'native'" style="display: flex">
            <FormItem
              :rules="[
                {
                  required: item.must,
                  message: '必填',
                  trigger: 'change',
                },
              ]"
              prop="nativeOne"
              label="籍贯"
            >
              <div @click="markedIndex(index)">
                <Select
                  @on-change="getCityList"
                  v-model="item.nativeOne"
                  style="width: 220px; margin-right: 5px"
                >
                  <Option
                    v-for="item in proLists"
                    :key="item.id"
                    :value="item.code"
                    >{{ item.name }}</Option
                  >
                </Select>
              </div>
            </FormItem>
            <FormItem
              :rules="[
                {
                  required: item.must,
                  message: '必填',
                  trigger: 'change',
                },
              ]"
              prop="nativeTwo"
              class="title-item"
            >
              <div>
                <!-- {{newCityList[`CityList${Inde}`]}} -->
                <Select v-model="item.nativeTwo" style="width: 223px">
                  <Option
                    v-for="item in newCityList[`CityList${index}`]"
                    :key="item.id"
                    :value="item.code"
                    >{{ item.name }}</Option
                  >
                </Select>
              </div>
            </FormItem>
          </div>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'change',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'highestedu'"
            label="最高学历"
          >
            <Select v-model="item.content">
              <Option value="博士研究生">博士研究生</Option>
              <Option value="硕士研究生">硕士研究生</Option>
              <Option value="本科">本科</Option>
              <Option value="专科">专科</Option>
              <Option value="其他">其他</Option>
            </Select>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'graduation'"
            label="毕业院校"
          >
            <Input
              v-model="item.content"
              placeholder="请输入毕业院校"
              :maxlength="20"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'unit'"
            label="工作单位"
          >
            <Input
              v-model="item.content"
              placeholder="请输入工作单位"
              :maxlength="30"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'position'"
            label="现任职务"
          >
            <Input
              v-model="item.content"
              placeholder="请输入职务"
              :maxlength="20"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                type: 'array',
                required: item.must,
                message: '必填',
                trigger: 'change',
              },
            ]"
            prop="contentString"
            v-else-if="item.code === 'discipline'"
            label="学科领域"
          >
            <Cascader
              :filterable="true"
              trigger="hover"
              :data="researchDirection"
              v-model="item.contentString"
            ></Cascader>
          </FormItem>
          <div v-else-if="item.code === 'title'" style="display: flex">
            <FormItem
              :rules="[
                {
                  required: item.must,
                  message: '必填',
                  trigger: 'change',
                },
              ]"
              change
              prop="titleOne"
              label="职称"
            >
              <Select
                v-model="item.titleOne"
                style="width: 220px; margin-right: 5px"
              >
                <Option
                  v-for="item in subjectOption"
                  :key="item.id"
                  :value="item.titleCode + ''"
                  >{{ item.titleName }}</Option
                >
              </Select>
            </FormItem>
            <FormItem
              :rules="[
                {
                  required: item.must,
                  message: '必填',
                  trigger: 'blur',
                },
              ]"
              prop="titleTwo"
              class="title-item"
            >
              <Input
                v-model="item.titleTwo"
                style="width: 220px; margin-right: 5px"
                placeholder="请输入职称"
                :maxlength="50"
              ></Input>
            </FormItem>
          </div>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'research'"
            label="研究方向"
          >
            <Input
              v-model="item.content"
              placeholder="请输入研究方向"
              :maxlength="30"
            ></Input>
          </FormItem>
          <FormItem
            :rules="[
              {
                required: item.must,
                message: '必填',
                trigger: 'blur',
              },
              {
                pattern:
                  /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                message: '格式错误',
                trigger: 'blur',
              },
            ]"
            prop="content"
            v-else-if="item.code === 'idnum'"
            label="身份证号"
          >
            <Input
              v-model="item.content"
              placeholder="请输入身份证号码"
              :maxlength="18"
            ></Input>
          </FormItem>
        </Form>
        <div style="position: relative">
          <div
            v-if="newArrayFrom.length === index + 1"
            @click="addDeepObj()"
            class="add"
          >
            添加其他参会人员
          </div>
          <div class="del" @click="delNewArrayFrom(index)">删除参会人员</div>
        </div>
      </div>
      <div v-if="signUps.length !== 0" @click="handleSubmit" class="submit">
        提交
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheRegistrationForm",
  components: {},
  data() {
    return {
      // 假设接口返回的数组
      signUps: [],
      // 接口需要的表单格式
      confereeArrays: {
        keyId: 0,
        meetingId: this.$route.query.id,
        userId: "",
        signUpDtos: [],
      },
      keyId: -1,
      newArrayFrom: [], // 传给接口的报名表单数组
      proLists: [], // 省列表
      newCityList: {
        CityList0: [], // 市列表
      },
      researchDirection: [], // 学科领域列表
      subjectOption: [], // 职称列表
      Inde: 0,
    };
  },
  methods: {
    // 失去焦点判断是否已经有用户了,有则回填
    blur(phone, index) {
      if (phone === "") {
        this.$refs["disabled" + index][0].$refs.input.removeAttribute(
          "readOnly"
        );
        return;
      }
      this.isExist(phone, index);
    },
    // 手机号获取userId
    async isExist(phone, index) {
      const isExistResp = await this.$apis.userServe.isExist({
        account: phone,
      });
      if (!isExistResp.data) {
        const checkUserResp = await this.$apis.userServe.checkUser({
          userId: isExistResp.content.userId,
          meetingId: this.$route.query.id,
        });
        // 判断该手机号是否已经报名此会议
        if (checkUserResp.data === 0) {
          this.newArrayFrom.forEach((it) => {
            if (it.keyId == index) {
              it.userId = isExistResp.content.userId;
              it.signUpDtos.forEach((it) => {
                if (it.code == "name") {
                  it.content = isExistResp.content.realname
                    ? isExistResp.content.realname
                    : "";
                }
              });
            }
          });
          if (isExistResp.content.realname === undefined) return; // 判断是否该手机号下面有姓名,有姓名自动填写并禁止修改,否则可以手动填写
          this.$refs["disabled" + index][0].$refs.input.setAttribute(
            "readOnly",
            true
          );
        } else {
          // 如果已报名 清除姓名和手机号
          this.newArrayFrom.forEach((it) => {
            if (it.keyId == index) {
              it.userId = "";
              it.signUpDtos.forEach((it) => {
                if (it.code == "name" || it.code == "phone") {
                  it.content = "";
                }
              });
            }
          });
          this.$refs["disabled" + index][0].$refs.input.removeAttribute(
            "readOnly"
          );
          this.$Message.error("该手机号已报名");
        }
      } else {
        this.$refs["disabled" + index][0].$refs.input.removeAttribute(
          "readOnly"
        );
      }
    },
    markedIndex(index) {
      this.Inde = index;
    },
    // 数据特殊处理
    commaSplice() {
      this.newArrayFrom.map((it) => {
        it.signUpDtos.map((it) => {
          switch (it.code) {
            case "discipline":
              if (!it.hasOwnProperty("contentString")) return;
              if (
                it.contentString.length == 0 ||
                typeof it.contentString == "string"
              )
                return;
              it.content = it.contentString.join(",");
              break;
            case "title":
              it.content = `${it.titleOne},${it.titleTwo}`;
              break;
            case "native":
              it.content = `${it.nativeOne},${it.nativeTwo}`;
              break;
          }
        });
      });
    },
    // 表单处理
    disposeForm() {
      this.signUps.forEach((it) => {
        this.confereeArrays.signUpDtos.push({
          code: it.code,
          content: "",
          must: it.must,
          sort: 0,
          value: it.value,
        });
      });
    },
    // 获取省列表
    async proList() {
      const resp = await this.$apis.userServe.proList();
      this.proLists = resp.content.provinceList;
    },
    // 获取市列表
    async cityList(code) {
      const resp = await this.$apis.userServe.cityList({
        provinceCode: code,
      });
      this.$set(
        this.newCityList,
        "CityList" + this.Inde,
        resp.content.cityList
      );
    },
    getCityList(code) {
      this.cityList(code);
    },
    // 拉取学科领域列表
    async getOneList() {
      const { data } = await this.$apis.userServe.getRelationList();
      this.researchDirection = [...data];
    },
    // 获取职称级别下拉框数据
    async getFormTitleOption() {
      const { data } = await this.$apis.userServe.getTitleList();
      this.subjectOption = [...data];
    },
    // 表单提交
    async handleSubmit() {
      this.commaSplice(); // 处理成接口需要的数据
      const e = this.deleteArray(); // 处理掉多余的属性形成最终的表单
      let newArray = [];
      this.$refs.formValidate.forEach((it) => {
        it.validate((v) => {
          newArray.push(v);
        });
      });
      let status = newArray.every((it) => {
        return it;
      });
      if (status) {
        const resp = await this.$apis.userServe.setSignUp(JSON.stringify(e));
        if (resp.data.resultCode === "200") {
          this.$emit("meetingSubmit");
          this.$Message.success("提交成功");
        } else {
          this.$Message.error(resp.data.resultDesc);
        }
      } else {
        this.$Message.error("请查看是否填写正确");
      }
    },
    // 删除表单
    delNewArrayFrom(index) {
      if (this.newArrayFrom.length > 1) {
        this.newArrayFrom.splice(index, 1);
      }
    },
    // 拷贝增加
    addDeepObj() {
      this.confereeArrays.keyId = ++this.keyId;
      let newObj = this.$global.deepClone(this.confereeArrays);
      this.newArrayFrom.push(newObj);
    },
    // 提交前将多余数据清除掉
    deleteArray() {
      let applyArray = this.$global.deepClone(this.newArrayFrom);
      let newApply = applyArray.map((it) => {
        delete it.keyId;
        if (it.userId == "") {
          delete it.userId;
        }
        it.signUpDtos.map((it) => {
          delete it.nativeOne;
          delete it.nativeTwo;
          delete it.titleOne;
          delete it.titleTwo;
          delete it.contentString;
        });
        return it;
      });
      return newApply;
    },
    async getDetail() {
      const resp = await this.$apis.recomendServe.getMeetingDetails({
        id: this.$route.query.id,
        projectId: 1,
      });
      this.signUps = resp.data.signUps;
    },
  },
  computed: {},
  watch: {
    signUps() {
      this.disposeForm();
      this.addDeepObj();
    },
  },
  created() {
    this.getDetail();
  },
  mounted() {
    this.proList();
    this.getOneList();
    this.getFormTitleOption();
  },
};
</script>

<style scoped lang="scss">
.form-enroll {
  .xing {
    position: relative;
    top: 0;
    left: 0;
    span {
      color: rgb(255, 0, 0);
      font-size: 12px;
    }
  }
  .h {
    font-size: 16px;
    color: #0344a1;
    font-weight: bold;
    margin-bottom: 25px;
  }
  .form {
    width: 80%;
    background: rgb(255, 255, 255);
    margin: 0 auto;
    padding: 30px 30px;
    border-top: 1px solid #d2d2d2;

    .del {
      position: absolute;
      top: 0;
      right: 0;
      color: #d1073c;
      cursor: pointer;
    }
    .add {
      position: absolute;
      top: 0;
      left: 80px;
      color: #2245be;
      cursor: pointer;
    }
  }
  .form:nth-child(2) {
    border: none;
  }
}
.submit {
  width: 100px;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
  text-align: center;
  margin: 0 auto;
  background: #4585f5;
  color: #fff;
  cursor: pointer;
}
::v-deep .ivu-input {
  background: #f4f8ff;
  color: #999999;
}
::v-deep .ivu-select-single {
  .ivu-select-selection {
    background: #f4f8ff;
    color: #999999;
  }
}
.title-item {
  &::v-deep .ivu-form-item-content {
    margin-left: 0 !important;
  }
}
</style>
